export enum ConflictErrorOrigin {
    USER_GROUP_CREATION = 'User Group',
    ACL_ENTRY_CREATION = 'ACL Entry',
}
